import iconLeftArrow from './icons/icon_arrow_left.png'
import iconRightArrow from './icons/icon_arrow_right.png'

import iconLeftArrowSvg from './icons/icon_arrow_left.svg'
import iconRightArrowSvg from './icons/icon_arrow_right.svg'

import imgArc1 from './images/arc_1.png'
import imgArc2 from './images/arc_2.png'
import imgArc3 from './images/arc_3.png'
import imgArc4 from './images/arc_4.png'
import imgArc5 from './images/arc_5.png'
import imgArc6 from './images/arc_6.png'
import imgArc7 from './images/arc_7.png'
import imgGoldCol from './images/golden_collection.png'
import iconCt from './icons/ct.png'
import iconStar from './icons/star.png'
import imgShare from './icons/share.png'
import imgPlay from './images/play.png'
import iconClose from './icons/close.png'

export default () => {
	// icon close in popup schedule

	document.querySelector('.schedule-popup__close')
		? (document.querySelector('.schedule-popup__close').src = iconClose)
		: null

	//icon close in quiz popup

	document.querySelector('.quiz-popup__close') ? (document.querySelector('.quiz-popup__close').src = iconClose) : null

	//imgs in programm line slider
	document.querySelectorAll('.item__share_img').forEach((el) => {
		el.src = imgShare
	})
	document.querySelectorAll('.item__play_img').forEach((el) => {
		el.src = imgPlay
	})

	document.querySelectorAll('.golden-collection__star').forEach((el) => {
		el.src = iconStar
	})

	document.getElementById('gold-col') ? (document.getElementById('gold-col').src = imgGoldCol) : null

	//footer CT img
	document.querySelector('.footerDtr') ? (document.getElementById('footerDtr').src = iconCt) : null

	// img arcs
	document.getElementById('arc--1') ? (document.getElementById('arc--1').src = imgArc1) : null
	document.getElementById('arc--2') ? (document.getElementById('arc--2').src = imgArc2) : null
	document.getElementById('arc--3') ? (document.getElementById('arc--3').src = imgArc3) : null
	document.getElementById('arc--4') ? (document.getElementById('arc--4').src = imgArc4) : null
	document.getElementById('arc--5') ? (document.getElementById('arc--5').src = imgArc5) : null
	document.getElementById('arc--6') ? (document.getElementById('arc--6').src = imgArc6) : null
	document.getElementById('arc--7') ? (document.getElementById('arc--7').src = imgArc7) : null

	// slider arrows

	document.querySelectorAll('.carousel__button--prev .carousel__button_img').forEach((el) => {
		el.src = iconLeftArrow
	})
	document.querySelectorAll('.carousel__button--next .carousel__button_img').forEach((el) => {
		el.src = iconRightArrow
	})

	document.querySelectorAll('.carousel__button--prev .carousel__icon').forEach(icon => icon.innerHTML = iconLeftArrowSvg)
	document.querySelectorAll('.carousel__button--next .carousel__icon').forEach(icon => icon.innerHTML = iconRightArrowSvg)

}
